import React from "react";
import Modal from "react-modal";
import { ClassNames, css } from "@emotion/core";
import styled from "@emotion/styled";
import { Flex } from "../Boxes";

const defaultModalDialogStyle = css`
  position: relative;
  top: 89px;
  width: 100%;
  background: #fff;
  z-index: 1000;
  background: #000;
  background-clip: padding-box;
  outline: 0;
`;
const defaultOverlayStyle = css`
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  transition: opacity 0.15s linear;
  overflow-y: scroll;
  z-index: 99999;
`;

const CloseButton = styled.button`
  position: absolute;
  top: -45px;
  right: 0;
  width: 55px;
  height: 55px;
  color: #fff;
  font-size: 40px;
  z-index: 999;
  opacity: 0.25;
  transition: opacity 0.4s;
  background: transparent;
  outline: 0;
  border: 0;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
`;

type VideoModalProps = {
  youtubeID: string;
  closeModal: () => void;
};

const VideoModal = ({ youtubeID, closeModal }: VideoModalProps) => {
  return (
    <ClassNames>
      {({ css: classCSS }) => {
        return (
          <Modal
            isOpen={true}
            className={classCSS`${defaultModalDialogStyle}`}
            overlayClassName={classCSS`${defaultOverlayStyle}`}
            onRequestClose={closeModal}
          >
            <Flex flexDirection="column" alignItems="center" maxWidth="900px" mx="auto" position="relative">
              <CloseButton onClick={closeModal}>×</CloseButton>
              <iframe
                width="100%"
                height="500"
                src={`https://www.youtube-nocookie.com/embed/${youtubeID}?autoplay=1`}
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </Flex>
          </Modal>
        );
      }}
    </ClassNames>
  );
};

export default VideoModal;
